<template>
  <div class="error-body-section">
    <div class="error-body-section__wrap">
      <p class="c-regist__comment">{{ message }}</p>
      <ul
        v-if="JSON.parse(descriptions) && JSON.parse(descriptions).length > 0"
        class="p-error__notes"
      >
        <li
          v-for="(description, index) in JSON.parse(descriptions)"
          :key="`description_${index}`"
          class="p-error__note"
        >
          {{ description }}
        </li>
      </ul>
    </div>

    <action-buttons-section
      class="error-body-section__action-buttons"
      scrollTargetSelector=".error-body-section"
      :visible="true"
    >
      <atom-link-button
        :linkText="$tc('common.toLogin')"
        :url="loginUrl"
        :isOpenAsBlank="false"
        colorType="secondary"
      />
    </action-buttons-section>
  </div>
</template>
<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import ActionButtonsSection from '@/components/common/form/ActionButtonsSection.vue'
import AtomLinkButton from '@/components/atoms/AtomLinkButton.vue'

export default defineComponent({
  name: 'ErrorBodySection',
  components: {
    ActionButtonsSection,
    AtomLinkButton,
  },
  props: {
    message: {
      type: String,
      default: '',
    },
    descriptions: {
      type: [],
      default: () => [],
    },
  },
  setup() {
    const loginUrl = `${process.env.VUE_APP_BROWSER_CAN_REDIRECT_TO_APP_BASE_URL}#/login`

    return {
      loginUrl,
    }
  },
})
</script>
<style scoped lang="scss">
.error-body-section {
  width: 100%;
  min-height: calc(100vh - 48px - 80px);
  padding: 80px 16px;
  text-align: center;
  background: $gray1;

  &__wrap {
    max-width: 840px;
    margin: 0 auto;
  }

  &__action-buttons {
    bottom: 0;
  }

  @media screen and (min-width: $responsiveTabletWidth) {
    padding: 80px 20px;
  }
}

.c-regist {
  &__comment {
    margin-top: 16px;
    @include fontSetTextMedium(17);

    line-height: 1.41;
    letter-spacing: 0.04em;
  }
}

.p-error {
  &__notes {
    margin: 20px 30px;
    list-style: none;

    > * + * {
      margin-top: 1em;
    }
  }

  &__note {
    @include fontSetTextMedium();
  }
}
</style>
